









































































































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import helperFormat from "../../mixins/HelperFormat.vue";

@Component
export default class CCTVHistoryIterator extends Mixins(helperFormat) {
    @Prop() data!: Array<any>;
    @Prop(Object) props!: object;
    @Prop(Boolean) loading!: boolean;

    toggle: string = "grid";
    headers: Array<object> = [
        {
            text: "Preview",
            value: "preview",
            align: "left",
            sortable: false
        },
        {
            text: "Modified",
            value: "modified",
            align: "left"
        },
        {
            text: "File name",
            value: "name",
            align: "left"
        },
        {
            text: "Size",
            value: "size",
            align: "left"
        },
        {
            text: "Duration",
            value: "duration",
            align: "left"
        },
        {
            text: "Actions",
            value: "name",
            align: "left",
            sortable: false
        }
    ];
}
